import { Component, Input, Output, EventEmitter} from '@angular/core'
import {PageChangeDto} from "../../../models/page-change-dto";
import {ImpersonateDto} from "../../../models/impersonate-dto";

@Component({
  selector: 'app-st-impersonation-floating-banner',
  templateUrl: './st-impersonation-floating-banner.component.html',
  styleUrls: ['./st-impersonation-floating-banner.component.scss'],
  standalone: false
})
export class StImpersonationFloatingBannerComponent {

  @Input()
  idVal: string = 'floatingBannerId';

  @Input()
  primary: boolean = false;

  @Input()
  disabled: boolean = false;

  @Input()
  label: string = 'Button';

  @Input()
  impersonatedEmail: any = null;

  @Input()
  username: string = '';

  @Input()
  roleName: string = '';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000'

  @Output()
  exitViewAs: EventEmitter<ImpersonateDto> = new EventEmitter<ImpersonateDto>();

  public get classes(): string[] {
    const mode = this.primary ? 'st-button-primary' : 'st-button-secondary';
    return [mode];
  }

  public onExitViewAs(): void {
    const dto: ImpersonateDto = {
      username: this.username,
      impersonatedEmail: this.impersonatedEmail,
      roleName: this.roleName
    }
    this.exitViewAs.emit(dto);
  }
}
